(function() {
    'use strict';

    angular
        .module('szallodak-accommodationservices', []);
})();
